// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"yn_a bag_tg bag_pq bag_uh"};